import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Button, Col, Row, Spinner } from "reactstrap";

const ClubInfo = () => {
  const { t } = useTranslation();
  const { club, loading } = useSelector((state) => state.Club);
  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "20px" }}>
        <Spinner color="primary" />
        <div>Chargement en cours...</div>
      </div>
    );
  }
  return (
    <Row className="d-flex justify-content-center" style={{ marginTop: 30 }}>
      <Col md="10">
        <Row>
          {/* Première Colonne */}
          <Col md={5}>
            <div style={styles.infoProfile}>
              <span style={styles.titreInfo}>
                {t("profile.clubInfo.clubName")}:{" "}
              </span>
              {club?.nameFr}
            </div>
            <div style={styles.infoProfile}>
              <span style={styles.titreInfo}>
                {t("profile.clubInfo.clubCategory")}:{" "}
              </span>{" "}
              {club?.category}
            </div>
            <div style={styles.infoProfile}>
              <span style={styles.titreInfo}>
                {t("profile.clubInfo.city")}:{" "}
              </span>{" "}
              {club?.city}
            </div>
            <div
              style={{ marginBottom: "5px", fontSize: "18px", font: "Poppins" }}
            >
              <span style={styles.titreInfo}>
                {t("profile.clubInfo.clubDescription")}:
              </span>
            </div>
            <div
              style={{
                marginBottom: "35px",
                fontSize: "18px",
                font: "Poppins",
                maxWidth: "70%",
              }}
            >
              {club?.description || t("profile.clubInfo.noDescription")}
            </div>
          </Col>

          {/* Deuxième Colonne */}
          <Col md={7} style={{ position: "relative" }}>
            <div style={styles.infoProfile}>
              <span style={styles.titreInfo}>
                {t("profile.clubInfo.managerName")}:{" "}
              </span>
              {club?.managerName}
            </div>
            <div style={styles.infoProfile}>
              <span style={styles.titreInfo}>
                {t("profile.clubInfo.managerEmail")}:{" "}
              </span>
              {club?.email}
            </div>
            <div style={styles.infoProfile}>
              <span style={styles.titreInfo}>
                {t("profile.clubInfo.managerRole")}:{" "}
              </span>
              {club?.managerRole}
            </div>
            <div style={styles.infoProfile}>
              <span style={styles.titreInfo}>
                {t("profile.clubInfo.phoneNumber")}:{" "}
              </span>{" "}
              {club?.phone}
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

const styles = {
  titreInfo: {
    color: "#000000",
  },
  infoProfile: {
    marginBottom: "35px",
    fontSize: "18px",
    font: "Poppins",
  },

  statInfo: {
    marginBottom: "18px",
    fontSize: "16px",
    font: "Poppins",
  },
  listeItem: {
    marginBottom: 2,
  },
};
export default ClubInfo;
